import React from 'react';
import { Link } from 'react-router-dom';
import { IconUsers, IconTrophy, IconCalendar, IconMapPin } from '@tabler/icons-react';
import { SPORTS_LIST, LEAGUE_STATUS } from '../../data/leagueSports';

const LeagueCard = ({ league }) => {
  const sport = SPORTS_LIST.find(s => s.id === league.sport);

  const getStatusBadge = (status) => {
    const badges = {
      [LEAGUE_STATUS.DRAFT]: { label: 'Draft', class: 'status-draft' },
      [LEAGUE_STATUS.REGISTRATION]: { label: 'Open', class: 'status-open' },
      [LEAGUE_STATUS.IN_PROGRESS]: { label: 'In Progress', class: 'status-active' },
      [LEAGUE_STATUS.COMPLETED]: { label: 'Completed', class: 'status-completed' },
      [LEAGUE_STATUS.CANCELLED]: { label: 'Cancelled', class: 'status-cancelled' }
    };

    return badges[status] || badges[LEAGUE_STATUS.DRAFT];
  };

  const statusBadge = getStatusBadge(league.status);

  return (
    <Link to={`/leagues/${league.id}`} className="ls-league-card">
      <div className="ls-league-card-header">
        <span className={`ls-league-status ${statusBadge.class}`}>
          {statusBadge.label}
        </span>
      </div>

      <div className="ls-league-card-body">
        <h3 className="ls-league-name">{league.name}</h3>
        <p className="ls-league-sport">{sport?.name || league.sport}</p>

        {league.description && (
          <p className="ls-league-description">
            {league.description.length > 100
              ? `${league.description.substring(0, 100)}...`
              : league.description}
          </p>
        )}

        <div className="ls-league-meta">
          <div className="ls-meta-item">
            <IconUsers size={16} />
            <span>{league.memberCount || 0} members</span>
          </div>

          <div className="ls-meta-item">
            <IconTrophy size={16} />
            <span>{league.format?.replace('-', ' ')}</span>
          </div>

          {league.startDate && (
            <div className="ls-meta-item">
              <IconCalendar size={16} />
              <span>{new Date(league.startDate).toLocaleDateString()}</span>
            </div>
          )}
        </div>

        {league.location && (
          <div className="ls-league-location">
            <IconMapPin size={14} /> {league.location}
          </div>
        )}
      </div>

      {league.userRole && (
        <div className="ls-league-card-footer">
          <span className="ls-user-role-badge">
            {league.userRole === 'admin' ? 'Admin' : 'Player'}
          </span>
        </div>
      )}
    </Link>
  );
};

export default LeagueCard;
